import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";

const CheckButton = ({
  onClick,
  className,
  loading = false,
}: {
  loading?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  return loading ? (
    <LoadingOutlined className={`${className} loading`} />
  ) : (
    <CheckOutlined className={className} onClick={onClick} />
  );
};
export default CheckButton;
